import { Box, Breadcrumbs, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import { useDispatch, useSelector } from "react-redux";
import { DrawerReducerAction } from "../../store/drawer/slice";
import { BreadcrumbSeparator } from "../../components/Icons";
import { useEffect } from "react";
import { BreadcrumbSagaAction } from "../../store/breadcrumb/saga";
import { breadcrumbSelector } from "../../store/breadcrumb/selector";
import { breadcrumbMap } from "../../utils/appConstants";
import MultiSelectClientDropdown from "./MultiSelectClientDropdown";

const Header = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const breadcrumbs = useSelector(breadcrumbSelector) as {
    label: string;
    path?: string;
  }[];

  useEffect(() => {
    const currentPath = location.pathname;
    if (breadcrumbMap[currentPath]) {
      dispatch(BreadcrumbSagaAction.updateBreadcrumbs({ path: currentPath }));
    }
  }, [location.pathname, dispatch]);

  const openDrawer = () => {
    dispatch(DrawerReducerAction.setDrawerOpen(true));
  };

  return (
    <Box className="fixed top-0 left-0 w-full lg:w-[calc(100%-256px)] flex-1 bg-white shadow-sm p-4 z-50 lg:ml-[256px]" role="banner">
      <Box className="flex md:flex-nowrap items-center justify-between gap-4">
        <Box className="flex items-center gap-4 w-full">
          <button
            type="button"
            onClick={openDrawer}
            className="cursor-pointer lg:hidden bg-transparent border-none p-0"
            aria-label="Open navigation menu"
            aria-expanded={false}
          >
            <MenuIcon aria-hidden="true" />
          </button>

          <Breadcrumbs
            aria-label="breadcrumb"
            separator={BreadcrumbSeparator}
            className="truncate"
          >
            {breadcrumbs.map((item, index) => {
              const isLast = index === breadcrumbs.length - 1;
              const isFirst = index === 0;
              return (
                <Typography
                  key={index}
                  onClick={() => {
                    if (!item?.path) return;
                    const isChild = index === 1;
                    const hasSubChild = breadcrumbs.length > 2;
                    if (isChild && hasSubChild) {
                      navigate(-1);
                    } else {
                      navigate(item.path as string);
                    }
                  }}
                  className={`truncate ${
                    item?.path ? "cursor-pointer" : ""
                  } hover:text-black ${
                    isFirst
                      ? "!text-primary-black-950 !text-lg !font-medium"
                      : isLast
                      ? "text-gray-800 !text-base !font-medium"
                      : "text-gray-600 !text-sm !font-medium"
                  }`}
                  role={item?.path ? "button" : undefined}
                  tabIndex={item?.path ? 0 : undefined}
                  aria-current={isLast ? "page" : undefined}
                  onKeyDown={(e) => {
                    if (item?.path && (e.key === 'Enter' || e.key === ' ')) {
                      e.preventDefault();
                      const isChild = index === 1;
                      const hasSubChild = breadcrumbs.length > 2;
                      if (isChild && hasSubChild) {
                        navigate(-1);
                      } else {
                        navigate(item.path as string);
                      }
                    }
                  }}
                >
                  {item?.label}
                </Typography>
              );
            })}
          </Breadcrumbs>
        </Box>

        <Box className="flex flex-col sm:flex-row items-center gap-3 w-full sm:justify-end">
          <MultiSelectClientDropdown />
          {/* <ClientDropdown /> */}
        </Box>
      </Box>
    </Box>
  );
};

export default Header;
